import React from 'react';
import { SimulationConfig } from './types';
import { VisualStylesSection } from './VisualStylesSection';
import { ShapeSettingsSection } from './ShapeSettingsSection';
import { SphereDisplaySettings } from './SphereDisplaySettings';
import { TrailSettingsSection } from './TrailSettingsSection';
import { ImpactFXSection } from './ImpactFXSection';
import { LayerSortingSection } from './LayerSortingSection';
import { GlobalVisualsSection } from './GlobalVisualsSection';
import { CollapsibleSection } from './CollapsibleSection';

interface VisualsTabProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const VisualsTab: React.FC<VisualsTabProps> = ({ config, setConfig }) => (
  <div className="flex flex-col w-full">
    <VisualStylesSection config={config} setConfig={setConfig} />
    
    <CollapsibleSection title="Shape & Geometry" icon="fa-shapes" darkMode={config.darkMode}>
        <ShapeSettingsSection config={config} setConfig={setConfig} />
    </CollapsibleSection>

    <CollapsibleSection title="Sphere Studio" icon="fa-circle-notch" darkMode={config.darkMode}>
        <SphereDisplaySettings config={config} setConfig={setConfig} />
    </CollapsibleSection>

    <CollapsibleSection title="Trail Dynamics" icon="fa-wind" darkMode={config.darkMode}>
        <TrailSettingsSection config={config} setConfig={setConfig} />
    </CollapsibleSection>

    <CollapsibleSection title="Impact Effects" icon="fa-burst" darkMode={config.darkMode}>
        <ImpactFXSection config={config} setConfig={setConfig} />
    </CollapsibleSection>

    <CollapsibleSection title="Layer Sorting" icon="fa-layer-group" darkMode={config.darkMode}>
        <LayerSortingSection config={config} setConfig={setConfig} />
    </CollapsibleSection>

    <CollapsibleSection title="Global Visuals" icon="fa-wand-magic-sparkles" darkMode={config.darkMode}>
        <GlobalVisualsSection config={config} setConfig={setConfig} />
    </CollapsibleSection>
  </div>
);
